import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const spinnerVariants = cva(
  "inline-block animate-spin rounded-full border-2 border-current/30 border-t-current",
  {
    variants: {
      variant: {
        default: "size-4",
        sm: "size-3",
        lg: "size-5",
        xl: "size-6",
        "2xl": "size-8",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface SpinnerProps
  extends
    React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof spinnerVariants> {}

function Spinner({
  ref,
  className,
  variant,
  ...props
}: SpinnerProps & { ref?: React.Ref<HTMLSpanElement> }) {
  return (
    <span
      ref={ref}
      role="status"
      aria-label="Loading"
      className={cn(spinnerVariants({ variant, className }))}
      {...props}
    >
      <span className="sr-only">Loading</span>
    </span>
  );
}

export { Spinner, spinnerVariants };
export default Spinner;
